import { createContext, useContext, useEffect, useState, useSyncExternalStore } from "react";
import * as vault from "../lib/vault";

const LockCtx = createContext(null);

// Lock again if the app has been in the background longer than this.
const AUTO_LOCK_MS = 60 * 1000;

export function LockProvider({ children }) {
  const [ready, setReady] = useState(false);
  // Re-render whenever the vault locks, unlocks or changes.
  useSyncExternalStore(vault.subscribe, vault.getState);

  useEffect(() => {
    vault.loadMeta().finally(() => setReady(true));
  }, []);

  useEffect(() => {
    let hiddenAt = null;
    const onVisibility = () => {
      if (document.visibilityState === "hidden") {
        hiddenAt = Date.now();
      } else if (hiddenAt && Date.now() - hiddenAt > AUTO_LOCK_MS) {
        vault.lock();
      }
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);

  let status = "loading";
  if (ready) {
    if (!vault.isSetUp()) status = "setup";
    else status = vault.isUnlocked() ? "unlocked" : "locked";
  }

  return (
    <LockCtx.Provider value={{ status, lock: vault.lock }}>{children}</LockCtx.Provider>
  );
}

export const useLock = () => useContext(LockCtx);
